import React from 'react';
import { isClientSide } from '../../utils/ssrUtils';

type LanguageContextType = {
  language: string;
  switchLanguage: () => void;
};

export const LanguageContext = React.createContext({
  language: 'fr',
  switchLanguage: () => {},
});

type Props = {};
type State = LanguageContextType;

export class LanguageContextProvider extends React.Component<Props, State> {
  /* eslint-disable react/no-unused-state */
  constructor(props: Props) {
    super(props);
    this.state = {
      language: (isClientSide && window.COUNTRY_CODE) || 'fr',
      switchLanguage: this.swicthLanguage,
    };
  }

  swicthLanguage = () => {
    this.setState((prevState: State) => ({
      language: prevState.language === 'fr' ? 'uk' : 'fr',
    }));
  };

  render() {
    return (
      <LanguageContext.Provider value={this.state}>
        {this.props.children}
      </LanguageContext.Provider>
    );
  }
}

export const withLanguage = <P extends object>(
  Component: React.ComponentType<P>,
) => {
  const ComponentWithUser: React.FC<Pick<
    P,
    Exclude<keyof P, keyof LanguageContextType>
  >> = props => (
    <LanguageContext.Consumer>
      {(language: LanguageContextType) => (
        <Component {...(props as P)} {...language} />
      )}
    </LanguageContext.Consumer>
  );
  return ComponentWithUser;
};
